// extracted by mini-css-extract-plugin
export var close = "mega-menu-module--close--e2d47";
export var flyin = "mega-menu-module--flyin--32d99";
export var header__menu = "mega-menu-module--header__menu--a5b2d";
export var hidden = "mega-menu-module--hidden--d6eae";
export var hoverFrontend = "mega-menu-module--hover-frontend--abfd9";
export var main_item = "mega-menu-module--main_item--5352c";
export var main_item__title = "mega-menu-module--main_item__title--b25a4";
export var menu__div__wrap = "mega-menu-module--menu__div__wrap--bb417";
export var menu__inner = "mega-menu-module--menu__inner--3333e";
export var show = "mega-menu-module--show--578d0";
export var sm = "mega-menu-module--sm--f7abb";
export var sub_menu__block = "mega-menu-module--sub_menu__block--97da2";